import React from "react";
// outsource
import { Button, DatePicker, Input } from "antd";
import { SearchOutlined, DownloadOutlined, SyncOutlined } from "@ant-design/icons";
import moment from "moment";

const weekFormat = "ddd DD/MM";
const startOfString = "week";

const PayoutToolbar = ({
  currentWeekStart,
  keyword,
  setKeyword,
  setPage,
  selectedRowKeys,
  handleWeekChange,
  handlePreviousWeek,
  handleNextWeek,
  nextDisabled,
  handleCompletePayout,
  downloadPopup,
  totalCash,
  totalBank,
  totalPayout,
  formatMoney,
  onRecalculate,
  recalculating,
}) => {
  // -------------------------- VAR --------------------------
  const customWeekStartEndFormat = (value) =>
    `${value.clone().startOf(startOfString).format(weekFormat)} - ${value
      .clone()
      .endOf(startOfString)
      .format(weekFormat)}`;

  // -------------------------- MAIN --------------------------
  return (
    <div className="payout-toolbar-grid">
      {/* Row 1 */}
      <div className="payout-col1">
        <span className="payout-label">Period</span>
        <DatePicker
          format={customWeekStartEndFormat}
          picker="week"
          onSelect={handleWeekChange}
          value={moment(currentWeekStart)}
          allowClear={false}
          className="payout-period-select"
        />
      </div>
      <div className="payout-btn-pair">
        <Button type="primary" className="payout-nav-btn" onClick={handlePreviousWeek}>Previous</Button>
        <Button
          type="primary"
          className="payout-nav-btn payout-complete-btn"
          disabled={nextDisabled}
          onClick={handleNextWeek}
        >
          Next
        </Button>
      </div>
      <div className="payout-recalculate-group">
        <Button
          type="primary"
          icon={<SyncOutlined spin={recalculating} />}
          disabled={recalculating}
          onClick={onRecalculate}
          className="payout-btn-action"
        >
          Recalculate
        </Button>
      </div>

      {/* Row 2 */}
      <div className="payout-col1">
        <Input
          className="payout-search"
          prefix={<SearchOutlined />}
          placeholder="Enter Name to search"
          value={keyword}
          onChange={(e) => {
            setKeyword(e.target.value);
            setPage(1);
          }}
        />
      </div>
      <div className="payout-btn-pair">
        <Button type="primary"
          className="payout-nav-btn payout-complete-btn"
          disabled={!selectedRowKeys.length}
          onClick={downloadPopup}
          icon={<DownloadOutlined />}
        >
          Download
        </Button>
        <Button
          type="primary"
          className="payout-nav-btn payout-complete-btn"
          disabled={!selectedRowKeys.length}
          onClick={handleCompletePayout}
        >
          Complete Payout
        </Button>
      </div>
      <div className="payout-summary-group">
        <span>Total Cash: <b className="payout-summary-value">${formatMoney(totalCash)}</b></span>
        <span>Total Bank: <b className="payout-summary-value">${formatMoney(totalBank)}</b></span>
        <span>Total Payout: <b className="payout-summary-value">${formatMoney(totalPayout)}</b></span>
      </div>
    </div>
  );
};

export default PayoutToolbar;
